import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks"
import { LogoSpinnerComponent } from "../../../../../lib/spinner/spinnerLogo"
import { colors } from "../../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../../ui/icons/arrow-left"
import { Layout } from "../../../../../ui/layout"
import { ButtonComponent } from "../../../../../ui/molecules/button/newButton"
import { MenuItems } from "../../../../../ui/organisms/navbar/dto"
import { GetNewMeasureById, NewMeasureCreation, NewMeasureValidation, resetGetNewMeasureByIdStatus, resetNewMeasureCreationStatus, resetNewMeasureValidationStatus, setNewMeasureIdtoUpdate } from "../../slice"
import { AddNewCodexMeasureFormsStep1 } from "./forms"

export function AddNewCodexMeasureStep1() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const sessionState = useAppSelector(state => state.session)
    const newMeasureState = useAppSelector(state => state.newMeasure)

    useEffect(() => {
        if (newMeasureState.newMeasureValidationStatus === 'successfully') {
            dispatch(resetNewMeasureValidationStatus())
            dispatch(NewMeasureCreation(newMeasureState.newMeasureCreationRequest))
        }
    }, [newMeasureState.newMeasureValidationStatus])

    useEffect(() => {
        if (newMeasureState.newMeasureCreationStatus === 'successfully' && newMeasureState.newMeasureCreationResponse !== undefined) {
            dispatch(resetNewMeasureCreationStatus())
            dispatch(setNewMeasureIdtoUpdate(newMeasureState.newMeasureCreationResponse))
            dispatch(GetNewMeasureById(newMeasureState.newMeasureCreationResponse))
        }
    }, [newMeasureState.newMeasureCreationStatus])

    useEffect(() => {
        if (newMeasureState.getNewMeasureByIdStatus === 'successfully' && newMeasureState.getNewMeasureByIdResponse !== undefined) {
            dispatch(resetGetNewMeasureByIdStatus())
            navigate('/addNewCodexMeasureStep2')
        }
    }, [newMeasureState.getNewMeasureByIdStatus])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PROVVEDIMENTI}
            breadcrumbItems={['Gestione Provvedimenti', 'Inserimento Nuovo Provvedimento Cliente']}
            headerLabel="Nuovo Provvedimento"
            customerName={sessionState.selected.customerName ?? undefined}
            customerCode={sessionState.selected.customerCode ?? undefined}
            rightBar={true}
            headerIcon={<ArrowLeftIcon onClick={() => navigate('/provvedimentiCliente')} color={colors.white} />}
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size="sm"
                        iconPosition="off"
                        variant="solid"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(NewMeasureValidation(newMeasureState.newMeasureCreationRequest))}
                    />
                </div>
            }
        >
            {(newMeasureState.newMeasureCreationStatus === 'loading' && newMeasureState.getNewMeasureByIdStatus === 'loading') && <LogoSpinnerComponent fullScreen />}
            <AddNewCodexMeasureFormsStep1 />
        </Layout>
    )
}